/** UTM / landing-page parameters the marketing site appends to its links into
 *  the app. Read from the URL only (never stored on the device), so the login
 *  page can hand them to the auth service for first-touch attribution on the
 *  server-side `signup_completed` event. */
const ATTRIBUTION_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "ref",
  "lp",
] as const;

export function attributionParams(search: string = window.location.search): URLSearchParams {
  const from = new URLSearchParams(search);
  const out = new URLSearchParams();
  for (const key of ATTRIBUTION_KEYS) {
    const v = from.get(key);
    if (v) out.set(key, v.slice(0, 200));
  }
  return out;
}

/** `&utm_source=…` etc., ready to append to an auth-service login URL that
 *  already has a query string. Empty when the visitor arrived without any. */
export function attributionSuffix(search: string = window.location.search): string {
  const params = attributionParams(search).toString();
  return params ? `&${params}` : "";
}
